import React from 'react';

const BlogPostSection: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  // This component is a simple div with a top margin to create vertical space
  // between the major sections of a blog post. It avoids using a generic <section> tag
  // to prevent inheriting unwanted global layout styles like padding.
  return (
    <div className="mt-12 md:mt-16">
      {children}
    </div>
  );
};

export default BlogPostSection;
